import { useEffect, useRef, useState } from "react";
import { Button, Empty, Input, Modal } from "antd";

export default function KnowledgeChatModal({ open, loading, messages, onCancel, onSubmit, onClear }) {
  const [question, setQuestion] = useState("");
  const messageListRef = useRef(null);

  useEffect(() => {
    if (!open) {
      setQuestion("");
    }
  }, [open]);

  useEffect(() => {
    const el = messageListRef.current;
    if (!el) return;
    el.scrollTop = el.scrollHeight;
  }, [messages, loading, open]);

  const handleSend = async () => {
    const content = question.trim();
    if (!content || loading) return;
    setQuestion("");
    await onSubmit?.(content);
  };

  return (
    <Modal
      title="知识库对话"
      open={open}
      centered
      onCancel={onCancel}
      width={720}
      footer={
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", gap: 8 }}>
            <Button type="primary" loading={loading} onClick={handleSend}>
              发送
            </Button>
            <Button onClick={onCancel} disabled={loading}>
              关闭
            </Button>
          </div>
          <div>
            <Button onClick={onClear} disabled={loading || messages.length === 0}>
              清空对话
            </Button>
          </div>
        </div>
      }
    >
      <div
        ref={messageListRef}
        style={{
          height: 420,
          overflowY: "auto",
          padding: 16,
          background: "#fafafa",
          border: "1px solid #f0f0f0",
          borderRadius: 8,
          marginBottom: 16,
        }}
      >
        {messages.length === 0 ? (
          <div style={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Empty description="输入问题后开始对话" />
          </div>
        ) : (
          messages.map((item, index) => (
            <div
              key={`${item.role}-${index}`}
              style={{
                display: "flex",
                justifyContent: item.role === "user" ? "flex-end" : "flex-start",
                marginBottom: 12,
              }}
            >
              <div
                style={{
                  maxWidth: "85%",
                  padding: "10px 12px",
                  borderRadius: 10,
                  background: item.role === "user" ? "#1677ff" : "#ffffff",
                  color: item.role === "user" ? "#ffffff" : "#111827",
                  border: item.role === "user" ? "none" : "1px solid #e5e7eb",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                }}
              >
                {item.content}
              </div>
            </div>
          ))
        )}
      </div>

      <Input.TextArea
        value={question}
        rows={4}
        maxLength={1000}
        placeholder="请输入你的问题"
        onChange={(event) => setQuestion(event.target.value)}
        onPressEnter={(event) => {
          if (event.shiftKey) return;
          event.preventDefault();
          handleSend();
        }}
      />
    </Modal>
  );
}
